module.exports = __webpack_public_path__ + "247dd959497fb646ad0dd70f27dce77a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/folder_icon_green_2x.png
// module id = 122
// module chunks = 0 1 2 3 4